import { render } from "./TaskActTemplate.vue?vue&type=template&id=5e7c4aec"
import script from "./TaskActTemplate.vue?vue&type=script&lang=js"
export * from "./TaskActTemplate.vue?vue&type=script&lang=js"

import "./TaskActTemplate.vue?vue&type=style&index=0&id=5e7c4aec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__